<script setup lang="ts">
import type { DirectSaleItemEntityWithPrice } from '~/types/directSale.type';

// PROPS
interface Props {
    directSale: DirectSaleItemEntityWithPrice;
}

const { directSale } = defineProps<Props>();

// MODEL
const offerAmount = defineModel<number>();

// COMPOSABLES
const { tt } = useTypedI18n();
const { trackOfferDecrement, trackOfferIncrement } = useTracking();
</script>

<template>
    <template v-if="offerAmount !== undefined">
        <UFormField :label="tt('negotiation.yourInitialOffer')" class="text-base">
            <SalePriceStepper
                v-model="offerAmount"
                :min-value="directSale.minNegotiationOffer"
                :max-value="directSale.buyNowPrice"
                @decrement="trackOfferDecrement"
                @increment="trackOfferIncrement"
            >
                <template #belowPrice>
                    <SaleFeesSimpleNotice :sale="directSale" />
                </template>
            </SalePriceStepper>
        </UFormField>

        <SaleSuccessProbabilityIndicator :selected-amount="offerAmount" :reference-amount="directSale.buyNowPrice" mode="negotiationBuyer" />
    </template>
</template>
